function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Edit",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "edycja",
  transform: "translate(1.000000, 1.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.64,1.43 C17.2543785,1.05423024 16.7335343,0.849816668 16.1952655,0.862991078 C15.6569968,0.876165489 15.1467764,1.10581491 14.78,1.5 L14.49,1.8 L14.49,1.8 L13.13,3.21 L13.13,3.21 L4.38,12.21 L4.38,12.21 L4.38,12.21 L4.38,12.21 C4.30622866,12.2945135 4.23934797,12.3848025 4.18,12.48 L1.61,17.16 C1.45180323,17.3825351 1.47715186,17.6867187 1.67,17.88 C1.77714271,17.9672052 1.91189354,18.0133042 2.05,18.0101661 C2.15855513,18.010933 2.2654525,17.9833466 2.36,17.93 L7,15.21 L7.11,15.12 L7.11,15.12 L7.27,15 L16,6.09 L16,6.09 L17.32,4.72 L17.74,4.28 C18.1181882,3.89358483 18.3238103,3.37051112 18.31,2.83 C18.2912028,2.29043459 18.0484106,1.78310761 17.64,1.43 Z",
  id: "Path",
  fill: "#48A9A1",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#48A9A1",
  points: "13.97 1.69 12.61 3.11 14.71 5.29 16.02 3.93"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.76,1 C16.3743785,0.624230244 15.8535343,0.419816668 15.3152655,0.432991078 C14.7769968,0.446165489 14.2667764,0.675814911 13.9,1.07 L13.61,1.37 L12.25,2.76 L12.25,2.76 L3.49,11.76 L3.49,11.76 C3.39710798,11.8588415 3.3134278,11.9659521 3.24,12.08 L0.72,16.71 C0.564394623,16.934896 0.593988384,17.239289 0.79,17.43 C0.891639584,17.5199627 1.02442675,17.5666177 1.16,17.56 C1.27171843,17.5608472 1.38182359,17.5333209 1.48,17.48 L6.1,14.77 L6.22,14.68 L6.22,14.68 L6.39,14.53 L15.07,5.65 L15.07,5.65 L16.38,4.29 L16.81,3.84 C17.1881882,3.45358483 17.3938103,2.93051112 17.38,2.39 C17.3645984,1.8630635 17.1417789,1.36351642 16.76,1 Z M16.07,1.72 C16.2620951,1.90297542 16.3736102,2.15478365 16.38,2.42 C16.3829683,2.69494307 16.2789843,2.96028159 16.09,3.16 L16,3.2 L14.66,1.7 C15.0500375,1.31227641 15.6799625,1.31227641 16.07,1.7 L16.07,1.72 Z M2.34,15.81 L3.92,12.89 L5.12,14.18 L2.34,15.81 Z M5.92,13.57 L4.53,12.08 L12.61,3.82 L14,5.29 L5.92,13.57 Z M14.71,4.57 L13.31,3.1 L14,2.42 L15.38,3.92 L14.71,4.57 Z",
  id: "Shape",
  fill: "#5C5C5C"
})));

var SvgEditPencil = function SvgEditPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EditPencil.7661d2be.svg";
export { ForwardRef as ReactComponent };